// ABOUTME: The Responsibilities card on Hold: the new Make It Right list first, tagged New, then up to three of the child's other lists.
// ABOUTME: Each row shows completed/total; the card is a summary and takes no input.

import { Box, Typography } from '@mui/material';
import type { CrossingHoldListRow } from '../../../../types/api';
import {
  CROSSING_CORAL, CROSSING_CORAL_SOFT, CROSSING_HAIRLINE, CROSSING_HEADLINE_INK, CROSSING_PLATE_BG, CROSSING_SUB_INK,
} from '../../../../theme/crossingTokens';
import { NEW_TAG, RESPONSIBILITIES } from './makeItRightCopy';

const MAX_OTHER_LISTS = 3;

interface ResponsibilitiesCardProps {
  newList: CrossingHoldListRow;
  otherLists: CrossingHoldListRow[];
}

function Row({ list, isNew }: { list: CrossingHoldListRow; isNew?: boolean }) {
  return (
    <Box
      component="li"
      sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, py: 0.75, px: 1, borderRadius: '10px',
        border: `1px solid ${isNew ? CROSSING_CORAL : CROSSING_HAIRLINE}`, backgroundColor: isNew ? CROSSING_CORAL_SOFT : 'transparent',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, minWidth: 0 }}>
        <Typography sx={{ fontSize: '14px', fontWeight: 600, lineHeight: 1.3 }}>{list.title}</Typography>
        {isNew && (
          <Typography component="span" sx={{ fontSize: '10px', fontWeight: 800, letterSpacing: '1px', textTransform: 'uppercase', color: CROSSING_CORAL }}>
            {NEW_TAG}
          </Typography>
        )}
      </Box>
      <Typography sx={{ fontSize: '12px', fontWeight: 700, color: CROSSING_SUB_INK, flexShrink: 0 }}>
        {list.completedItems}/{list.totalItems}
      </Typography>
    </Box>
  );
}

export default function ResponsibilitiesCard({ newList, otherLists }: ResponsibilitiesCardProps) {
  return (
    <Box
      data-testid="responsibilities-card"
      sx={{
        width: '100%', boxSizing: 'border-box', p: 1.5, textAlign: 'left', borderRadius: '14px',
        border: `1px solid ${CROSSING_HAIRLINE}`, backgroundColor: CROSSING_PLATE_BG, color: CROSSING_HEADLINE_INK,
      }}
    >
      <Typography component="h3" sx={{ fontFamily: 'Newsreader, serif', fontSize: '17px', fontWeight: 600, mb: 0.75 }}>
        {RESPONSIBILITIES}
      </Typography>
      <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 0.75 }}>
        <Row list={newList} isNew />
        {otherLists.slice(0, MAX_OTHER_LISTS).map(list => <Row key={list.id} list={list} />)}
      </Box>
    </Box>
  );
}
